module.exports = __webpack_public_path__ + "img/bohian.018251e1.jpg";